

















import _ from 'lodash';
import {
  ModalMixin, Modal, notify, AsyncBtn,
} from 'mycorems-app-shared';
import { User } from '../types';
import { update } from './index';

interface Data {
  firstName: string,
  lastName: string,
  task: Promise<void>|null,
}

export default ModalMixin.extend({
  props: {
    user: {
      type: Object as () => User,
      required: true,
    },
  },
  data(): Data {
    return {
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      task: null,
    };
  },
  computed: {
    title(): string {
      return `Edit User - ${this.firstName} ${this.lastName}`;
    },
  },
  methods: {
    update(): void {
      const user = _.cloneDeep(this.user);
      user.firstName = this.firstName;
      user.lastName = this.lastName;
      this.task = update(user);
      this.task.then(() => {
        notify.success('User edited.');
        this.$emit('ok', user);
        this.hide();
      });
    },
  },
  components: {
    Modal,
    AsyncBtn,
  },
});
